export default () => ({
  show: false,
  beenUpdated: false,
  wasRaised: false,
  statusAddress: null,
  statusCovenant: null,
  includes: ['professional', 'specialities'],
  entity: 'staff',
  entities: 'staffs',
  staffs: [],
  optionsComapnyStaff: [],
  optionsProfessionalSpecialities: [],
  staff: {
    professional_id: null,
    specialities: []
  },
  showModalPresent: false,
  showButtonNewStaff: false,
  nextStepButtonStaffsAddress: [
    {
      icon: '',
      text: 'Cadastrar Local de Atendimento',
      name: 'professional.company.addresses.create',
      action: null
    }
  ],
  nextStepButtonStaffsCovenants: [
    {
      icon: '',
      text: 'Cadastrar Convênios',
      name: 'professional.company.covenants.create',
      action: null
    }
  ],
  nextStepButtonStaffs: [
    {
      icon: '',
      text: 'Novo Profissional',
      name: 'professional.company.staffs.index',
      action: true
    },
    {
      icon: '',
      text: 'Honorários Médicos',
      name: 'professional.company.prices.index',
      action: null
    }
  ],
  // never use prefix v1.
  prefixRouter: 'professional.company.staffs',
  interval: null,
  isSearch: false,
  invite: {
    document: '',
    state: null,
    name: null,
    email: null
  }
})



// WEBPACK FOOTER //
// ./src/app/professional/company/staffs/resources/data.js